import React, { useState, useEffect } from "react";
import { PROGRESS_BG_DELETED, PROGRESS_BG_INSERTED, PROGRESS_BG_UNCHANGED } from "../../../../config/colors";
import {
  sectionWrapperClass,
  sectionTitleClass,
  progressWrapperClass,
  progressBarClass,
  sectionLinkClass,
} from "./styles";
import { Link } from "react-router-dom";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

type SectionProps = {
  title: string;
  isHeading: boolean;
  inserted: number;
  deleted: number;
  unchanged: number;
  link?: string;
};

const Section: React.FC<SectionProps> = (props) => {
  const { title, inserted, deleted, unchanged, isHeading, link } = props;

  const appInsights = useAppInsightsContext();

  const [insertedProgress, setInsertedProgress] = useState(0);
  const [deletedProgress, setDeletedProgress] = useState(0);
  const [unchangedProgress, setUnchangedProgress] = useState(0);

  useEffect(() => {
    const total = inserted + deleted + unchanged;

    const insertedProgress = ((inserted / total) * 100).toFixed(2);
    const deletedProgress = ((deleted / total) * 100).toFixed(2);
    const unchangedProgress = ((unchanged / total) * 100).toFixed(2);

    setInsertedProgress(Number(insertedProgress));
    setDeletedProgress(Number(deletedProgress));
    setUnchangedProgress(Number(unchangedProgress));
  }, [inserted, deleted, unchanged]);

  const component = (
    <div className={sectionWrapperClass}>
      <div className={progressWrapperClass}>
        <div className={progressBarClass} style={{ width: `${deletedProgress}%`, background: PROGRESS_BG_DELETED }} />
        <div className={progressBarClass} style={{ width: `${insertedProgress}%`, background: PROGRESS_BG_INSERTED }} />
        <div
          className={progressBarClass}
          style={{ width: `${unchangedProgress}%`, background: PROGRESS_BG_UNCHANGED }}
        />
      </div>
      <div className={sectionTitleClass} style={{ fontWeight: isHeading ? "700" : "400" }}>
        {title}
      </div>
    </div>
  );

  if (link) {
    return (
      <Link
        to={link}
        className={sectionLinkClass}
        onClick={() => {
          appInsights.trackEvent({ name: "View change text" });
        }}
      >
        {component}
      </Link>
    );
  }

  return <>{component}</>;
};

export default Section;
